<div role="main">
	<div class="container-fluid">
		<div class="row align-items-center">
			<h2 class="col mb-0">
				<span i18n="api documentation page/menu title">API Documentation</span>
			</h2>
		</div>
		<div class="row">
			<div class="col">
				<hr class="mt-0"/>
			</div>
		</div>

		<div class="row justify-content-center" *ngIf="apiDocumentationService.data.search">
			<div class="col-12 col-lg-6">
				<mat-form-field class="width-100 mb-3">
					<mat-label>Search</mat-label>
					<input type="text" #searchInput matInput [formControl]="searchControl" [matAutocomplete]="auto">
					<mat-autocomplete #auto="matAutocomplete" (optionSelected)="searchSelected($event)">
						<mat-option *ngFor="let result of searchResults" [value]="result" title="{{window.location.origin}}/api-documentation/{{result.location}}">
							<strong>{{result.title}}:</strong> {{result.summary}}...
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
		</div>

		<div class="row align-items-center page-not-found-container" *ngIf="pageNotFound">
			<div class="col-12 text-center">
				<h3>
					<span
						i18n="title conveying that some navigation has gone wrong"
					>Something just Zoned out!</span>
				</h3>
				<h2 i18n="the page could not be loaded sub header">Could Not Load Page</h2>
				<div class="error-details mb-3">
					<span
						i18n="page could not be loaded error|message telling user the requested page could not be loaded"
					>Sorry, something went wrong when trying to load the requested page. Please try another page or come back later.</span>
				</div>
				<div>
					<button mat-flat-button color="primary" (click)="back()">
						<span i18n="navigate back to documentation">Back</span>
					</button>
				</div>
			</div>
		</div>

		<div class="row api-container" *ngIf="!pageNotFound">
			<div class="col">
				<iframe title="API Documentation frame" class="api-iframe" id="api-docs" style="visibility: hidden; border: none;" (load)="iFrameLoaded()"></iframe>
			</div>
		</div>
	</div>
</div>
